import React from 'react';
import { IconProps } from '../types/types';

const TOMOERC20: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" role="img" {...props}><path fill="#242828" d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z"/><path fill="#fff" fillRule="evenodd" d="M7.756 3.267v4.488L5.512 10V5.511l2.244-2.244Zm6.733 8.978a4.489 4.489 0 0 1-8.978 0V10h2.244v2.245A2.247 2.247 0 0 0 10 14.489a2.247 2.247 0 0 0 2.245-2.244h2.244Z" clipRule="evenodd"/><path fill="#00E8B4" fillRule="evenodd" d="M14.489 7.756 12.244 10H5.512l2.244-2.244h6.734Z" clipRule="evenodd"/></svg>
);

export default TOMOERC20;
